<script lang="ts">
  import { formatRelativeTime } from "./utils";

  export let totalOpportunities: number;
  export let fullySynced: number;
  export let errors: number;
  export let lastSyncTime: string;
</script>

<div
  class="box-border flex h-full w-full min-w-0 flex-col justify-between rounded-xl border border-white/10 border-l-4 border-l-[#ff9900] bg-[#1b1e2e]/70 p-4 transition-all hover:border-white/20 hover:shadow-lg sm:p-6"
>
  <div class="mb-4 flex min-w-0 flex-wrap items-center gap-3">
    <div class="shrink-0 text-2xl">☁️</div>
    <div class="min-w-[160px] flex-1 text-[1.125rem] font-bold text-white">AWS Partner Central</div>
    <div
      class="px-3 py-1 bg-[rgba(255,153,0,0.2)] text-[#ffa500] rounded-2xl text-xs font-semibold border border-[rgba(255,153,0,0.3)]"
    >
      Source
    </div>
  </div>

  <div class="h-px bg-white/10 my-4" />

  <div class="flex flex-col gap-3">
    <div class="flex min-w-0 justify-between gap-3 text-sm">
      <span class="text-white/60 font-medium">Total:</span>
      <span class="text-white font-semibold flex items-center gap-2">{totalOpportunities}</span>
    </div>
    <div class="flex min-w-0 justify-between gap-3 text-sm">
      <span class="text-white/60 font-medium">Synced:</span>
      <span class="text-green-500 font-semibold flex items-center gap-2">{fullySynced}</span>
    </div>
    <div class="flex min-w-0 justify-between gap-3 text-sm">
      <span class="text-white/60 font-medium">Pending:</span>
      <span class="text-amber-500 font-semibold flex items-center gap-2">
        {totalOpportunities - fullySynced}
      </span>
    </div>
    <div class="flex min-w-0 justify-between gap-3 text-sm">
      <span class="text-white/60 font-medium">Errors:</span>
      <span class="text-red-500 font-semibold flex items-center gap-2">{errors}</span>
    </div>
  </div>

  <div
    class="flex justify-between mt-4 pt-4 border-t border-white/10 text-[0.813rem]"
  >
    <span class="text-white/50">Last Pull</span>
    <span class="text-white font-semibold">{formatRelativeTime(lastSyncTime)}</span>
  </div>
</div>
